/**
 * Impressum — oeffentliche Pflichtseite (CH) fuer app.invictaflow.ch.
 */
import { Link } from "react-router-dom";

export default function ImpressumPage() {
  return (
    <div className="min-h-screen bg-white text-slate-800" data-testid="impressum-page">
      <header className="max-w-3xl mx-auto px-6 py-5 flex items-center gap-2.5">
        <Link to="/" className="flex items-center gap-2.5">
          <img src="/invictaflow-logo.png" alt="InvictaFlow Logo" className="w-8 h-8 rounded-lg" />
          <span className="font-bold">InvictaFlow</span>
        </Link>
      </header>
      <main className="max-w-3xl mx-auto px-6 pb-16">
        <h1 className="text-3xl font-bold mb-8">Impressum</h1>
        <div className="space-y-6 text-sm leading-relaxed">
          <section>
            <h2 className="font-semibold text-base mb-2">Betreiberin der Plattform</h2>
            <p>
              InvictaX Group GmbH<br />
              Bahnhofstrasse 75<br />
              8620 Wetzikon<br />
              Schweiz
            </p>
          </section>
          <section>
            <h2 className="font-semibold text-base mb-2">Kontakt</h2>
            <p>
              E-Mail: <a href="mailto:info@invictax.ch" className="text-[#2563EB] underline">info@invictax.ch</a>
            </p>
          </section>
          <section>
            <h2 className="font-semibold text-base mb-2">Haftungsausschluss</h2>
            <p className="text-slate-600">
              Die Inhalte dieser Website wurden mit grösstmöglicher Sorgfalt erstellt. Die Betreiberin übernimmt
              jedoch keine Gewähr für die Richtigkeit, Vollständigkeit und Aktualität der bereitgestellten Inhalte.
              Haftungsansprüche gegen die Betreiberin wegen Schäden materieller oder immaterieller Art, die aus dem
              Zugriff oder der Nutzung bzw. Nichtnutzung der veröffentlichten Informationen entstehen, sind
              ausgeschlossen, soweit gesetzlich zulässig.
            </p>
          </section>
          <section>
            <h2 className="font-semibold text-base mb-2">Verweise auf Dienste Dritter</h2>
            <p className="text-slate-600">
              InvictaFlow verbindet sich mit ausdrücklicher Autorisierung der Nutzer mit Diensten Dritter
              (u.a. TikTok, Meta, LinkedIn, Pinterest, Google). Für die Inhalte und Datenverarbeitung dieser
              Dienste sind die jeweiligen Anbieter verantwortlich. Details regelt unsere{" "}
              <Link to="/privacy" className="text-[#2563EB] underline">Datenschutzerklärung</Link>.
            </p>
          </section>
          <section>
            <h2 className="font-semibold text-base mb-2">Urheberrechte</h2>
            <p className="text-slate-600">
              Die Urheber- und alle anderen Rechte an Inhalten, Bildern oder anderen Dateien auf dieser Website
              gehören ausschliesslich der InvictaX Group GmbH oder den speziell genannten Rechtsinhabern.
            </p>
          </section>
        </div>
        <div className="mt-10 text-xs text-slate-400 flex gap-4">
          <Link to="/" className="underline">Startseite</Link>
          <Link to="/privacy" className="underline">Datenschutzerklärung</Link>
          <Link to="/terms" className="underline">Nutzungsbedingungen</Link>
        </div>
      </main>
    </div>
  );
}
